import React from 'react';
import ArrowCounterClockwise from '@uber/base-icons/arrow-counter-clockwise';
import { Button, KIND, SIZE } from 'baseui/button';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { CANVAS_TOOLBAR } from '../../../constants/template-builder';
type UndoRedoButtonsPropsT = {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  overrides: Record<string, unknown>;
};
export function UndoRedoButtons({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  overrides
}: UndoRedoButtonsPropsT) {
  return <>
      <StatefulTooltip content={CANVAS_TOOLBAR.UNDO} placement={PLACEMENT.right} showArrow>
        <Button data-testid="toolbar-undo" onClick={onUndo} disabled={!canUndo} kind={KIND.tertiary} size={SIZE.xSmall} overrides={overrides}>
          <ArrowCounterClockwise size={CANVAS_TOOLBAR.ICON_SIZE} />
        </Button>
      </StatefulTooltip>

      <StatefulTooltip content={CANVAS_TOOLBAR.REDO} placement={PLACEMENT.right} showArrow>
        <Button data-testid="toolbar-redo" onClick={onRedo} disabled={!canRedo} kind={KIND.tertiary} size={SIZE.xSmall} overrides={overrides}>
          <span style={{
          display: 'inline-flex',
          transform: 'rotateY(180deg)'
        }}>
            <ArrowCounterClockwise size={CANVAS_TOOLBAR.ICON_SIZE} />
          </span>
        </Button>
      </StatefulTooltip>
    </>;
}